
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import config from "@/config/config";
import gateway from "@/lib/request/gateway";
import PostPolicy from "@/lib/model/gateway/post-policy";
import _ from "lodash";
import Auth from "@/lib/common/auth";
import ImageCropper from "@/views/ai-builder-v3/components/imageCropper.vue";

@Component({
  components: {
    ImageCropper
  }
})
export default class UploadImg extends Vue {
  @Prop({ default: "examLogoUrl", type: String }) private imgType!: string;
  @Prop({ default: "", type: String }) private img!: string;
  @Prop({
    default: "推荐尺寸为750*1624，推荐格式为JPG、JPEG、PNG。推荐大小小于2M",
    type: String
  })
  private text!: string;
  @Prop({ default: true, type: Boolean }) private cutImage!: boolean;

  loading = false;
  headers = {};
  imageUrl = "";
  postPolicy: PostPolicy = new PostPolicy();
  defaultBG =
    "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png";
  file: any = null; //用户选取的本地图片

  updateStatus = false;

  get uploadUrl() {
    return _.trim(config.accountUrl) + "/api/common/uploadOss";
  }
  get token() {
    return Auth.token;
  }

  @Watch("img", { immediate: true })
  onImgChange(val: string) {
    // this.imageUrl = val === this.defaultBG ? "" : val; //默认图片不在上传处展示
    if (val !== this.defaultBG) {
      this.updateStatus = Boolean(val);
      this.imageUrl = val; //默认图片不在上传处展示
    }
  }
  mounted() {
    // this.imageUrl = this.img;
  }

  onChange(e: any) {
    if (e.srcElement.files[0]) {
      console.dir(e.srcElement.files[0]);
      this.file = e.srcElement.files[0];

      if (!this.cutImage) {
        return this.uploadImg({
          filename: "test",
          file: this.file
        });
      }
    }
  }
  cancel() {
    //
  }
  checkedImg = ""; //裁剪后的图片
  confirm(base64: any) {
    this.checkedImg = base64;
    this.uploadImg({
      filename: "test",
      file: this.base64ToFile(base64, "test")
    });
  }
  // base64图片转file的方法（base64图片, 设置生成file的文件名）
  base64ToFile(base64: any, fileName: string) {
    // 将base64按照 , 进行分割 将前缀  与后续内容分隔开
    const data = base64.split(",");
    // 利用正则表达式 从前缀中获取图片的类型信息（image/png、image/jpeg、image/webp等）
    const type = data[0].match(/:(.*?);/)[1];
    // 从图片的类型信息中 获取具体的文件格式后缀（png、jpeg、webp）
    const suffix = type.split("/")[1];
    // 使用atob()对base64数据进行解码  结果是一个文件数据流 以字符串的格式输出
    const bstr = window.atob(data[1]);
    // 获取解码结果字符串的长度
    let n = bstr.length;
    // 根据解码结果字符串的长度创建一个等长的整形数字数组
    // 但在创建时 所有元素初始值都为 0
    const u8arr = new Uint8Array(n);
    // 将整形数组的每个元素填充为解码结果字符串对应位置字符的UTF-16 编码单元
    while (n--) {
      // charCodeAt()：获取给定索引处字符对应的 UTF-16 代码单元
      u8arr[n] = bstr.charCodeAt(n);
    }
    // 利用构造函数创建File文件对象
    // new File(bits, name, options)
    const file = new File([u8arr], `${fileName}.${suffix}`, {
      type: type
    });
    // 将File文件对象返回给方法的调用者
    return file;
  }

  afterUpload(e: any) {
    this.loading = false;
    if (e.code === 0) {
      this.imageUrl = e.data.url;
    }
  }
  uploadImg(data: { filename: string; file: File }) {
    const { filename, file } = data;
    console.log(filename);
    this.loading = true;
    const isJPG =
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG) {
      this.$message.error("上传图片只能是 JPG/JPEG/PNG 格式!");
      this.loading = false;
      return false;
    }
    if (!isLt2M) {
      this.$message.error("上传图片过大!");
      this.loading = false;
      return false;
    }
    // 上传图片到oss
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
        gateway
          .upload(postRes, file)
          .then((res: any) => {
            console.log("upload res : ", res);
            this.updateStatus = true;
          })
          .finally(() => {
            this.imageUrl = tempUrl;
            this.$emit("change", this.imageUrl);
            this.updateStatus = true;
          });
      }
    });
  }

  uploadSuccess(e: any) {
    this.loading = false;
    if (e.code === 0) {
      this.imageUrl = e.data.url;
      this.updateStatus = true;
      this.$message.success("上传成功");
    }
  }
  delImg() {
    this.$emit("change", "");
  }
  error() {
    console.log("error");
  }
}
